import invariant from 'tiny-invariant'

interface TurnstileSiteKeyEnv {
  NEXT_PUBLIC_TURNSTILE_SITE_KEY?: string
  VITE_TURNSTILE_SITE_KEY?: string
}

interface TurnstileSiteKeyOptions {
  env?: TurnstileSiteKeyEnv
}

export function getTurnstileSiteKey({ env = getDefaultEnv() }: TurnstileSiteKeyOptions = {}) {
  const siteKey = env.NEXT_PUBLIC_TURNSTILE_SITE_KEY || env.VITE_TURNSTILE_SITE_KEY

  invariant(
    siteKey,
    'Missing Turnstile site key environment variable. Set NEXT_PUBLIC_TURNSTILE_SITE_KEY or VITE_TURNSTILE_SITE_KEY.',
  )

  return siteKey
}

export function shouldSendTurnstileTokenHeader(token: string) {
  return token.length > 0
}

function getDefaultEnv(): TurnstileSiteKeyEnv {
  return {
    NEXT_PUBLIC_TURNSTILE_SITE_KEY: process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY,
    VITE_TURNSTILE_SITE_KEY: process.env.VITE_TURNSTILE_SITE_KEY,
  }
}
